import { render, staticRenderFns } from "./MainPage.vue?vue&type=template&id=9fb11374&scoped=true"
import script from "./MainPage.vue?vue&type=script&lang=js"
export * from "./MainPage.vue?vue&type=script&lang=js"
import style0 from "./MainPage.vue?vue&type=style&index=0&id=9fb11374&prod&lang=scss"
import style1 from "./MainPage.vue?vue&type=style&index=1&id=9fb11374&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9fb11374",
  null
  
)

export default component.exports